// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Fragment, Translate, PropTypes } from '@plesk/ui-library';
import Flipper from './Flipper';

const About = ({
    aboutPleskSrc,
    devTeamSrc,
    productName,
    panelVersion,
    patch,
    pleskKeyId,
    linkEula,
    linkForum,
    linkFacebook,
    linkTwitter,
    linkSite,
    linkBlog,
}) => (
    <Fragment>
        <Flipper
            className="plesk-about"
            front={(
                <figure className="about-image">
                    <img src={aboutPleskSrc} />
                </figure>
            )}
            back={(
                <figure className="about-image">
                    <img src={devTeamSrc} />
                </figure>
            )}
        />
        <p>
            {productName}
            <br />
            <Translate content="panelVersion" /> {panelVersion}
            {
                patch
                    ? <span> <Translate content="installedPatchVersion" params={{ patch }} /></span>
                    : null
            }
        </p>
        <p>
            <Translate content="licenseKey" />{`: ${pleskKeyId} | `}<a href="/plesk/license/"><Translate content="linkLicenseManagement" /></a>
        </p>
        <p>
            <Translate content="productDescription" />
        </p>
        <ul>
            <li>
                <Translate
                    content="visitSite"
                    params={{ link: <a href={linkSite} target="_blank"><Translate content="linkSite" /></a> }}
                />
            </li>
            <li>
                <Translate
                    content="visitBlog"
                    params={{ link: <a href={linkBlog} target="_blank"><Translate content="linkBlog" /></a> }}
                />
            </li>
            <li>
                <Translate content="followUs" />{': '}
                <a href={linkFacebook} target="_blank">{'Facebook'}</a>{' | '}
                <a href={linkTwitter} target="_blank">{'Twitter'}</a>
            </li>
            <li>
                <Translate
                    content="visitForum"
                    params={{ link: <a href={linkForum} target="_blank"><Translate content="linkForum" /></a> }}
                />
            </li>
        </ul>
        <p>
            <Translate content="copyright" />
        </p>
        <p>
            <Translate
                content="readEula"
                params={{ link: <a href={linkEula} target="_blank"><Translate content="linkEula" /></a> }}
            />
        </p>
    </Fragment>
);

About.propTypes = {
    aboutPleskSrc: PropTypes.string.isRequired,
    devTeamSrc: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    panelVersion: PropTypes.string.isRequired,
    patch: PropTypes.string,
    pleskKeyId: PropTypes.string.isRequired,
    linkEula: PropTypes.string.isRequired,
    linkForum: PropTypes.string.isRequired,
    linkFacebook: PropTypes.string.isRequired,
    linkTwitter: PropTypes.string.isRequired,
    linkSite: PropTypes.string.isRequired,
    linkBlog: PropTypes.string.isRequired,
};

About.defaultProps = {
    patch: null,
};

export default About;



// WEBPACK FOOTER //
// ./views/admin/about/index/About.js